import { InputDateField, InputField, InputLabel, InputRadioField } from '@presentation/components';
import { InputWrapper } from '@presentation/components/InputWrapper';
import { useTranslation } from '@presentation/utils';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import type { FC } from 'react';
import { FaMars, FaVenus } from 'react-icons/fa';
import type { MtLitterPageFormValues, MtLitterPageProps } from '../types';

export const FormStepDogs: FC<MtLitterPageProps> = (props) => {
  const { mode, born, adminValidated } = props;
  const { values } = useFormikContext<MtLitterPageFormValues>();
  const { translate } = useTranslation();

  const litterBecameBorn = useMemo(() => {
    return born === false && values?.born === true;
  }, [born, values?.born]);

  const malesFemalesCountDisabled = useMemo(() => {
    if (mode === 'view') return true;
    if (mode === 'new') return false;
    if (adminValidated === false || litterBecameBorn) return false;
    return true;
  }, [adminValidated, litterBecameBorn, mode]);

  return (
    <>
      <InputWrapper split>
        <InputLabel required icon={<FaMars />}>
          {translate('common.inputs.malesCount.label')}
        </InputLabel>
        <InputField
          hideNumberArrows
          disabled={malesFemalesCountDisabled}
          name="malesCount"
          type="number"
          inputMode="numeric"
          min={0}
          max={99}
        />
      </InputWrapper>

      <InputWrapper split last>
        <InputLabel required icon={<FaVenus />}>
          {translate('common.inputs.femalesCount.label')}
        </InputLabel>
        <InputField
          hideNumberArrows
          disabled={malesFemalesCountDisabled}
          name="femalesCount"
          type="number"
          inputMode="numeric"
          min={0}
          max={99}
        />
      </InputWrapper>

      <InputWrapper split>
        <InputLabel required icon={<FaMars />}>
          {translate('common.inputs.malesLeftCount.label')}
        </InputLabel>
        <InputField
          hideNumberArrows
          disabled={mode === 'view'}
          name="malesLeftCount"
          type="number"
          inputMode="numeric"
          min={0}
          max={99}
        />
      </InputWrapper>

      <InputWrapper split last>
        <InputLabel required icon={<FaVenus />}>
          {translate('common.inputs.femalesLeftCount.label')}
        </InputLabel>
        <InputField
          hideNumberArrows
          disabled={mode === 'view'}
          name="femalesLeftCount"
          type="number"
          inputMode="numeric"
          min={0}
          max={99}
        />
      </InputWrapper>

      <InputWrapper split>
        <InputLabel required>{translate('common.inputs.vaccinationDate.label')}</InputLabel>
        <InputDateField name="vaccinationDate" disabled={mode === 'view' || !values.vaccinated} />
      </InputWrapper>

      <InputWrapper split last>
        <InputLabel required>{translate('common.inputs.vaccinated.label')}</InputLabel>
        <InputRadioField<boolean>
          grow
          disabled={mode === 'view'}
          name="vaccinated"
          options={[
            { value: true, label: translate('common.options.vaccinated.true') },
            { value: false, label: translate('common.options.vaccinated.false') },
          ]}
        />
      </InputWrapper>

      <InputWrapper split>
        <InputLabel required>{translate('common.inputs.wormed.label')}</InputLabel>
        <InputRadioField<boolean>
          grow
          disabled={mode === 'view'}
          name="dewormed"
          options={[
            { value: true, label: translate('common.options.wormed.true') },
            { value: false, label: translate('common.options.wormed.false') },
          ]}
        />
      </InputWrapper>

      <InputWrapper split last>
        <InputLabel required>{translate('common.inputs.chipped.label')}</InputLabel>
        <InputRadioField<boolean>
          grow
          disabled={mode === 'view'}
          name="microchipped"
          options={[
            { value: true, label: translate('common.options.chipped.true') },
            { value: false, label: translate('common.options.chipped.false') },
          ]}
        />
      </InputWrapper>
    </>
  );
};
